module.exports = __webpack_public_path__ + "static/media/search-subject-img3.a75d7714.jpg";